import { Component, OnInit, Input } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import 'moment/locale/pt-br';
import * as moment_ from 'moment';
const moment = moment_;
moment.locale('pt-br');

import { VqsAuthService } from '@vqs/vqs-app';
import { VqsAppService } from '@vqs/vqs-app';
import { VqsUploadService } from '@vqs/vqs-app';
import { Upload } from '@vqs/vqs-app';

export interface AttachmentsItem { url: string; unique_name: string; file_name: string; }
export interface AttachmentsItemId extends AttachmentsItem { id: string; }

@Component({
  selector: 'vqs-tickets-new',
  templateUrl: './vqs-tickets-new.component.html',
  styleUrls: ['./vqs-tickets-new.component.css']
})
export class VqsTicketsNewComponent implements OnInit {

  @Input() config: any;
  @Input() modal: any;
  @Input() message: any;

  private Attachments_Collection: AngularFirestoreCollection<AttachmentsItem>;
  Attachments_Items: Observable<AttachmentsItemId[]>;
  private attachments_Items_array = [];
  private attachments_Items_array2 = [];

  public currentUpload: Upload;
  public sending: boolean;

  public attendants: any = [];

  public dues_timestamp: any = [
    { id: 0, name: 'TICKETS.SLA.LESS' },
    { id: 24, name: 'TICKETS.SLA1' },
    { id: 48, name: 'TICKETS.SLA2' },
    { id: 72, name: 'TICKETS.SLA3' },
    { id: 96, name: 'TICKETS.SLA4' },
    { id: 120, name: 'TICKETS.SLA5' },
    { id: 144, name: 'TICKETS.SLA6' },
    { id: 168, name: 'TICKETS.SLA7' },
    { id: 192, name: 'TICKETS.SLA8' },
    { id: 216, name: 'TICKETS.SLA9' },
    { id: 240, name: 'TICKETS.SLA10' }
  ];

  public priorities: any = [
    { id: 1, name: 'TICKETS.PRIORITY.CRITICAL'  },
    { id: 2, name: 'TICKETS.PRIORITY.HIGH' },
    { id: 3, name: 'TICKETS.PRIORITY.MODERATE' },
    { id: 4, name: 'TICKETS.PRIORITY.LOW' }
  ];

  constructor(
    private readonly afs: AngularFirestore,
    public vqsAuthService: VqsAuthService,
    private vqsAppService: VqsAppService,
    private vqsUploadService: VqsUploadService,
    private afFun: AngularFireFunctions,
  ) {
  }

  ngOnInit() {
    this.message.id = moment().unix().toString();
    this.Attachments_Collection = this.afs.collection<AttachmentsItem>('tickets/' + this.message.id + '/attachments');
    this.Attachments_Items = this.Attachments_Collection.snapshotChanges().pipe(
      map(actions => {
        this.attachments_Items_array = [];
        this.attachments_Items_array2 = [];
        return actions.map(a => {
          const data = a.payload.doc.data() as AttachmentsItem;
          const id = a.payload.doc.id;
          this.attachments_Items_array.push({ path: data.url, filename: data.file_name });
          this.attachments_Items_array2.push({ id: id, data: data });
          return { id, ...data };
        });
      }
    ));

    this.vqsAuthService.dbS.collection('users')
    .where('profile', '>=', 200)
    .get()
    .then(snapshotAttendants => {
      this.attendants = [];
      snapshotAttendants.forEach(docAttendants => {
        if((this.vqsAuthService.profile >= 200) ||
          (docAttendants.id === this.vqsAuthService.userId)) {
            this.attendants.push({
              id: docAttendants.id,
              name: docAttendants.data().name
            })
          }
      })
    });

  }


  deny(result) {
    const basePath = 'tickets/' + this.message.id + '/attachments/';
    for(let i=0; i < this.attachments_Items_array2.length; i++) {
      this.vqsUploadService.deleteUpload(basePath, this.attachments_Items_array2[i].id, this.attachments_Items_array2[i].data.unique_name);
    }
    this.modal.deny(result);
  }


  approve(result) {
    if (result['requester']) {
      this.sendTicket(result);
    } else {
      this.vqsAuthService.dbS
      .collection('users')
      .where('email', '==', result['email'])
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.sendTicket(result);
        } else {
          result['requester'] = snap.docs[0].id;
          this.sendTicket(result);
        }
      })
    }
  }


  sendTicket(result) {
    this.sending = true;

    let ticket = {
        creator_email: this.vqsAuthService.user.email,
        creator_name: this.vqsAuthService.user.displayName,
        due_timestamp: result['due_timestamp'] ? moment().add(result['due_timestamp'], 'hours').unix().toString() : 0,
        number: Number(result.id),
        priority: result['priority'],
        status: 'O',
        subject: result['subject'],
        to: result['email'],
        team: '',
        checked: 1,
        attendant: result['attendant'],
        timestamp: moment().unix(),
        requester: result['requester'],
    }

    if((this.config) && (this.config.requesterIsChildOf) &&
        (this.message.requesters) &&
        (this.vqsAppService.getObjByKey(this.message.requesters, 'id', result['requester'])) &&
        (this.vqsAppService.getObjByKey(this.message.requesters, 'id', result['requester'])[this.config.requesterIsChildOf])) {
        ticket[this.config.requesterIsChildOf] = this.vqsAppService.getObjByKey(this.message.requesters, 'id', result['requester'])[this.config.requesterIsChildOf]
    }

    const message = {
      timestamp: Number(result.id),
      subject: result['subject'],
      to: result['email'],
      from: [{
          name: this.vqsAuthService.user.displayName,
          email: this.vqsAuthService.user.email,
          photo: this.vqsAuthService.user.photoURL ? this.vqsAuthService.user.photoURL : null
      }],
      cc: [{
          name: '',
          email: result['email_cc'],
      }],
      cco: [{
          name: '',
          email: result['email_cco'],
      }],
      html: result['message'],
      hasAnexo: (this.attachments_Items_array.length > 0) ? true : false,
      files: this.attachments_Items_array
    }

    this.vqsAuthService.dbS.collection('tickets').doc(result.id).set(ticket).then(() => {
      this.vqsAuthService.dbS.collection('tickets').doc(result.id).collection('messages').add(message).then(() => {
        const data = {
              email: message.to,
              cc: result['email_cc'] ? result['email_cc'] : null,
              cco: result['email_cco'] ? result['email_cco'] : null,
              subject: '[#' + result.id + '] ' + message.subject,
              html: message.html,
              attachments: this.attachments_Items_array
          };
          this.afFun.httpsCallable('sendEmail')(data)
          .toPromise()
          .then(resp => {
            this.sending = false;
            this.modal.approve({ status: 'success', message: message });
          }, error => { this.sending = false; this.modal.approve({ status: 'error', message: message }); });
        }, error => { this.sending = false; this.modal.approve({ status: 'error', message: message }); });
    }, error => { this.sending = false; this.modal.approve({ status: 'error', message: message }); });
  }



  changeRequester(requester) {
    this.message.email = this.vqsAppService.getObjByKey(this.message.requesters, 'id', requester)['email'];
  }


  changeDepartaments(departament) {
    this.message.email = this.vqsAppService.getObjByKey(this.message.departaments, 'id', departament)['email'];
  }


  onUploadError(args: any) {
    console.log('onUploadError:', args);
  }


  onUploadSuccess(args: any, id) {
    this.currentUpload = new Upload(args[0]);
    const filename = (args[0].name).toLowerCase();
    const basePath = 'tickets/' + id + '/attachments';
    this.vqsUploadService.pushUpload(this.currentUpload, basePath, filename, null, null, null, { status: 'T' });
  }


  deleteFile(file, id) {
    const basePath = 'tickets/' + id + '/attachments/';
    this.vqsUploadService.deleteUpload(basePath, file.id, file.unique_name);
  }

}
